import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from './services/auth.service';
import { Observable, combineLatest } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';

export const authGuard: CanActivateFn = (route, state): Observable<boolean | UrlTree> => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const requiredRoles = route.data['roles'] as string[] | undefined;

  // Combine initialization signal with the actual auth state
  return authService.isInitialized$.pipe(
    switchMap(() => combineLatest([authService.user$, authService.userData$])),
    take(1),
    map(([user, userData]) => {
      // If there is no user, the user is not authenticated.
      if (!user) {
        // If the route is protected, redirect to the login page.
        return router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
      }

      // If the route is protected by roles, we need to check the user's data.
      if (requiredRoles && requiredRoles.length > 0) {
        if (userData && requiredRoles.includes(userData.role)) {
          return true; // User has the required role
        }
        // User does not have the required role, redirect to not-authorized.
        return router.createUrlTree(['/not-authorized']);
      }

      return true; // Authenticated and no role requirements
    })
  );
};